module.exports = __webpack_public_path__ + "img/VodkaCrystalHead.43976bb8.jpg";